import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { qrCode, parent } = gateway

// 1. 根据信息生成海报
export function createPoster (params) {
  return request({
    url: `${qrCode}/api/poster/compose/qrCode`,
    method: 'POST',
    data: params
  })
}

// 3. 获取referral信息
export function referralDetail (params) {
  return request({
    url: `${parent}/api/referral/progress/referrer/family`, // `${parent}/api/wx/courseStage/detail?studentId=${parmas.studentId}&courseStageId=${parmas.courseStageId}`,
    method: 'get',
    params
  })
}

// 3. 获取referral信息
export function getShareText (params) {
  return request({
    url: `${parent}/api/referral/poster/share/text`, // `${parent}/api/wx/courseStage/detail?studentId=${parmas.studentId}&courseStageId=${parmas.courseStageId}`,
    method: 'get',
    params
  })
}
